<template>
	<!-- eslint-disable no-mixed-spaces-and-tabs -->
	<div class="order-events">
		<h5>Timeline</h5>
		<div class="events-container">
			<div v-for="event in events" :key="event.id" class="item">
				<div class="created-date">
					{{
						displayDatetime(
							event.createdAt,
							'YYYY-MM-DD HH:mm ([UTC]Z)',
							event.timezone
						)
					}}
				</div>
				<div class="content">
					<div class="type">
						{{
							$t(
								`PORTAL.Deliveries.TIMELINES.${event.type}`,
								event.payload.parcelRefs
									? {
											parcelRef:
												event.payload.parcelRefs[0]
													.value
									  }
									: undefined
							)
						}}
					</div>
					<div class="extra-info">
						<div v-if="event.payload.pickupAt">
							<label>
								{{
									$t('PORTAL.Deliveries.TIMELINES.PICKUP_AT')
								}}
							</label>
							<span>
								:{{
									displayDatetime(
										event.payload.pickupAt,
										'YYYY-MM-DD HH:mm ([UTC]Z)',
										event.timezone
									)
								}}
							</span>
						</div>
						<div v-if="event.payload.deliveryBy">
							<label>
								{{
									$t(
										'PORTAL.Deliveries.TIMELINES.DELIVERY_BY'
									)
								}}
							</label>
							<span>
								:{{
									displayDatetime(
										event.payload.deliveryBy,
										'YYYY-MM-DD HH:mm ([UTC]Z)',
										event.timezone
									)
								}}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div v-if="!isEndedOrder" class="item" />
		</div>
	</div>
</template>

<script>
import { ORDER_STATUS_GROUP } from '@/utils/constants'
import { displayDatetime } from '@/utils/helpers'

export default {
	props: {
		events: {
			type: Array,
			required: true
		},
		orderStatus: {
			type: String,
			required: true
		}
	},
	computed: {
		isEndedOrder() {
			return ORDER_STATUS_GROUP.END.includes(this.orderStatus)
		}
	},
	methods: {
		displayDatetime
	}
}
</script>

<style scoped lang="scss">
.order-events {
	margin: 20px 0 10px 10px;

	.events-container {
		display: flex;
		flex-direction: column;
		margin-top: 20px;

		.item {
			display: flex;
			padding-bottom: 20px;
			position: relative;

			&:last-child {
				&::after {
					content: none;
				}
			}

			&::before {
				content: '';
				display: block;
				width: 20px;
				height: 20px;
				min-width: 20px;
				min-height: 20px;
				border-radius: 20px;
				background: lightgrey;
				margin-right: 10px;
				position: relative;
				z-index: 2;
			}

			&::after {
				content: '';
				height: calc(100% - 20px);
				width: 2px;
				background: lightgrey;
				position: absolute;
				z-index: 1;
				left: 9px;
				top: 20px;
			}

			.content {
				.type {
					font-weight: bold;
				}

				.extra-info {
					font-weight: normal;
					font-size: 12px;
					margin-left: 5px;

					label {
						margin: 0;
						width: 120px;
						font-weight: normal;
					}

					span {
						margin-left: 30px;
					}
				}
			}

			.created-date {
				width: 200px;
			}
		}
	}
}
</style>
